// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    dirty: false,
    raw: "b531f51",
    hash: "b531f51",
    distance: null,
    tag: null,
    semver: null,
    suffix: "b531f51",
    semverString: null,
    subenv: null,
    rev_count: "1"
};
/* tslint:enable */
